import React, { useState } from "react";
import { useEffect } from "react";
import PopupEthicalPledge from "./PopupEthicalPledge";

const ManagementTab1 = props => {
    const [popClass, setPopClass] = useState(false);

    const popClassToggle = () => {
        if (popClass) {
            setPopClass(false);
        } else {
            setPopClass(true);
        }
    };
    return (
        <>
            {/* 윤리경영 */}
            <section id="tab1" className="tab-cont">
                <div className="ethical-title">
                    <h2>kt MOS 북부 「新 윤리경영 원칙」</h2>
                    <h3>
                        「우리는 글로벌 1등 기업으로 성장하기 위해 올바른 의사결정과 윤리적 판단으로 회사의 미래를 도모」한다.
                        <br />
                        이를 위해 「고객최우선, 준법경영, 기본충실, 주인의식, 사회적책임」을 모든 ktMOS인이 공유하고 지켜야할 윤리경영 5대 행동원칙으로 삼고, 이를 적극 실천할 것을 다짐한다.
                    </h3>
                </div>
                <div className="ethical-rules-wrap gray-back-bg">
                    <ul className="list">
                        <li>
                            <div className="icon n01"></div>
                            <p className="sbj">
                                원칙 <b>01</b>
                            </p>
                            <p className="txt">
                                고객을 최우선 <br />
                                가치로 삼는다.
                            </p>
                        </li>
                        <li>
                            <div className="icon n02"></div>
                            <p className="sbj">
                                원칙 <b>02</b>
                            </p>
                            <p className="txt">
                                각종법규와 기준을 <br />
                                엄격히 준수한다.
                            </p>
                        </li>
                        <li>
                            <div className="icon n03"></div>
                            <p className="sbj">
                                원칙 <b>03</b>
                            </p>
                            <p className="txt">
                                기본과 원칙에 <br />
                                충실한다.
                            </p>
                        </li>
                        <li>
                            <div className="icon n04"></div>
                            <p className="sbj">
                                원칙 <b>04</b>
                            </p>
                            <p className="txt">
                                스스로 회사와 <br /> 내가 하나라는 주인 <br />
                                의식을 가진다.
                            </p>
                        </li>
                        <li>
                            <div className="icon n05"></div>
                            <p className="sbj">
                                원칙 <b>05</b>
                            </p>
                            <p className="txt">
                                국민기업으로서 <br />
                                사회적 책임과 <br />
                                의무를 다한다.
                            </p>
                        </li>
                    </ul>
                    <button type="button" onClick={popClassToggle} className="btn_nor red-line lg wide">
                        新 윤리경영 원칙 전문보기
                    </button>
                </div>
            </section>
            <PopupEthicalPledge show={popClass} onClose={() => setPopClass(false)} />
        </>
    );
};

export default ManagementTab1;
